import React, { ReactElement } from 'react';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import FilterChecklist from 'buyside/components/presentation/Filters/FilterChecklist/filterChecklist';
import FilterSelect from 'buyside/components/presentation/Filters/FilterSelect/filterSelect';
import FilterDatePicker from 'buyside/components/presentation/Filters/FilterDatePicker/filterDatePicker';
import FilterTextInput from 'buyside/components/presentation/Filters/FilterTextInput/filterTextInput';
import SelectableDropdown from 'buyside/components/presentation/SelectableDropdown/selectableDropdown';

import { labelizedFilterListOptions } from 'buyside/components/presentation/Filters/filterUtil';
import { whitePapersSortOrders } from 'buyside/util/ideaFilterConstants';
import { newMacroThematicUrl } from 'buyside/util/urlHelper';

const {
  esgs,
  geographies,
  globalMacros,
  sectors,
  whitePaperAttachmentFinancialModels,
  whitePaperAttachmentSecondary
} = labelizedFilterListOptions;

export const renderWhitePaperSideButton = (canWriteWhitePapers: boolean): ReactElement => (
  <>
    {canWriteWhitePapers && (
      <Button
        text="Submit Research"
        type={BUTTON_TYPES.MAJOR}
        size={BUTTON_SIZES.SMALL}
        url={newMacroThematicUrl()}
      />
    )}
  </>
);

export const renderWhitePaperSortOrders = (): ReactElement => (
  <FilterSelect paramName="sort_by" options={whitePapersSortOrders} borderless />
);

const WhitePaperIndexPageFilter = (): ReactElement => (
  <>
    <FilterTextInput
      id="wp-keyword-search"
      placeholder="Keyword Search"
      paramName="text"
      analyticsTag="keyword-search"
    />
    <SelectableDropdown title="ESG" analyticsTag="esgs">
      <FilterChecklist filterList={esgs} disabled={false} paramName="esgs[]" />
    </SelectableDropdown>
    <SelectableDropdown title="Geography" analyticsTag="geography">
      <FilterChecklist filterList={geographies} disabled={false} paramName="geographies[]" />
    </SelectableDropdown>
    <SelectableDropdown title="Global Macro" analyticsTag="globalMacros">
      <FilterChecklist filterList={globalMacros} disabled={false} paramName="global_macros[]" />
    </SelectableDropdown>
    <SelectableDropdown title="Sectors" analyticsTag="sectors">
      <FilterChecklist filterList={sectors} disabled={false} paramName="sectors[]" />
    </SelectableDropdown>
    <SelectableDropdown title="Date Submitted" analyticsTag="date-submitted" overflowVisible>
      <FilterDatePicker text="Submitted After" paramName="submitted_after" />
      <FilterDatePicker text="Submitted Before" paramName="submitted_before" />
    </SelectableDropdown>
    <SelectableDropdown title="Attachment Types" analyticsTag="attachment-types">
      <FilterChecklist
        filterList={whitePaperAttachmentFinancialModels}
        paramName="financial_model_types[]"
        title="Financial Model"
      />
      <FilterChecklist
        filterList={whitePaperAttachmentSecondary}
        paramName="secondary_types[]"
        title="Secondary Research"
      />
    </SelectableDropdown>
  </>
);

export default WhitePaperIndexPageFilter;
